<template>
    <link-cards-section
        class="link-cards-module"
        :title="attributes.linkCards_title"
        :slides="formattedSlides"
        :show-navigation-buttons="attributes.linkCardsSection_show_navigation_buttons"
    />
</template>

<script>
    import formatMediaObject from '../../../../utils/formatters/format-media-object';
    import LinkCardsSection from '../../../organisms/LinkCardsSection/LinkCardsSection.vue';

    export default {
        name: 'link-cards-module',

        components: { LinkCardsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format api data for the carousel.
             *
             * @returns {Array}
             */
            formattedSlides() {
                return (this.attributes.links || []).map((link) => ({
                    title: link.title,
                    text: link.text,
                    image: formatMediaObject.call(this, link.image),
                    externalLink: link.external_link,
                    to: link.page?.uri,
                    buttonText: link.button_text || this.$snippet('find_out_more', 'find out more'),
                }));
            },
        },
    };
</script>
